<template>
    <div class="md-layout" v-if="hasTeam">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <div class="custom-toolbar">
                <div class="custom-toolbar-start">
                    <router-link :to="{ name: 'Team Settings' }">
                        <h3 class="title">Team Settings</h3>
                    </router-link>
                    <h3 class="title">&nbsp;&nbsp; > &nbsp;&nbsp; Run Sheet</h3>
                </div>
            </div>
        </div>
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>description</md-icon>
                    </div>
                </md-card-header>
                <md-card-content>
                    <h5 class="card-title">Settings</h5>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100 layout-item">
                            <md-checkbox v-model="includeBarcodes" :disabled="isSaving">
                                Include item barcodes on runsheet
                            </md-checkbox>
                        </div>
                    </div>
                </md-card-content>
                <md-card-actions md-alignment="left">
                    <button class="custom-btn" @click="save" :disabled="isSaving">Save</button>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'RunSheetSettings',
    mixins: [GeneralMixin],
    data() {
        return {
            includeBarcodes: false,
            isSaving: false
        };
    },
    computed: {
        ...mapGetters({
            hasTeam: 'user/hasTeam'
        })
    },
    async mounted() {
        if (!this.hasTeam) 
            return;
        this.$_handleLoaderState(true);
        try {
            const resp = await handleRequests(`/api/settings/teams/runsheets/custom`, { method: 'get' });
            const payload = resp?.data || resp;
            if (payload && typeof payload.includeBarcodes === 'boolean') {
                this.includeBarcodes = payload.includeBarcodes;
            }
        } catch (e) {
            // silent: loader hides automatically
        } finally {
            this.$_handleLoaderState(false);
        }
    },
    methods: {
        async save() {
            this.isSaving = true;
            this.$_handleLoaderState(true, 'SAVING...');
            const teamId = this.$store.getters['user/user']?.teamId;
            if (!teamId) {
                this.$notifyError('Team not found.');
                this.$_handleLoaderState(false);
                this.isSaving = false;
                return;
            }
            const endpoint = `/api/settings/teams/runsheets/custom/${this.includeBarcodes ? 'enable' : 'disable'}`;
            try {
                const resp = await handleRequests(endpoint, { method: 'put' });
                const data = resp?.data || resp;
                if (data && typeof data.includeBarcodes === 'boolean') {
                    this.includeBarcodes = data.includeBarcodes;
                }
                this.$notifySuccess('Run sheet settings saved.');
            } catch (e) {
                showErrorMessage(this, 'Cannot save run sheet settings.', e);
            } finally {
                this.$_handleLoaderState(false);
                this.isSaving = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.card-icon {
    background: #2196f3 !important;
}
</style>
